import React from 'react';

import FORMATTERS from 'helpers/formatters';

import { Circle, StyledProgressBar, SummaryTable } from './styles';

const VARIANT_COLOR = {
  warning: 'rgb(0, 161, 194)',
  danger: 'rgb(237, 104, 4)',
  success: 'rgb(153, 102, 255)',
  info: '#b6c0cd',
  secondary: 'rgb(153, 102, 255)',
};

function List({ data }) {
  return (
    <>
      <StyledProgressBar className="mt-2">
        {data.map((item, index) => (
          <StyledProgressBar
            key={`income${index}`}
            id={item.variant}
            now={item.amount}
            isLast={index === data.length - 1}
          />
        ))}
      </StyledProgressBar>
      <SummaryTable className="mt-3 table table-hover">
        <thead>
          <tr>
            <th className="text-left">STATUS</th>
            <th className="text-right">QTDE</th>
            <th className="text-right">Total</th>
          </tr>
        </thead>
        <tbody>
          {data
            .filter(item => item.quantity > 0)
            .map(item => (
              <tr key={item.status_id}>
                <td className="text-left">
                  <span className="d-flex align-items-center">
                    <Circle color={VARIANT_COLOR[item.variant]} className="ml-2" />
                    {item.status}
                  </span>
                </td>
                <td className="text-right financial-value">
                  <span className="mr-2">{item.quantity}</span>
                </td>
                <td className="text-right financial-value">
                  <span className="mr-2">{FORMATTERS.NUMBER(item.amount)}</span>
                </td>
              </tr>
            ))}
        </tbody>
      </SummaryTable>
    </>
  );
}

export default List;
